import { useSessionStorage, validateRedirectUri } from '@cheqroom/hooks';

export const REDIRECT_URI_STORAGE_KEY = 'CHEQROOM_REDIRECT_KEY';

/** Re-export for callers that need redirect validation without the hook. */
export { validateRedirectUri };

/**
 * Persists post-login redirect_uri from URL param across steps. Pass searchParams.get('redirect_uri')
 * on mount. Only validated values are stored (untrusted input); callers must still validate before redirect.
 */
const validate = validateRedirectUri as (value: string | null | undefined) => string | undefined;

export const useRedirectUri = (
	initialValue?: string | null
): [redirectUri: string | undefined, clearRedirectUri: () => void] => {
	const validated: string | undefined = validate(initialValue ?? undefined);
	const [redirectUri, , clearRedirectUri] = useSessionStorage<string>(REDIRECT_URI_STORAGE_KEY, validated);
	return [redirectUri, clearRedirectUri];
};
